import { createFeatureSelector, createSelector } from '@ngrx/store';

import { listTileReducerFactory } from '../../../pillar/dashboard/store/reducers/list-tile.reducerFactory';
import { TileState } from '../../../pillar/dashboard/store/state/TileState';
import * as actions from '../../../pillar/dashboard/store/actions/';

import { ModuleConfiguration } from '../../dynamicDataSet.module.config';
import { DynamicDataSetListModel } from '../../models/DynamicDataSetListModel';
import { DynamicDataSetModel } from '../../models/DynamicDataSetModel';
import { DynamicDataSetReducer } from './dynamicDataSet.reducer';
import { DynamicRuleProfileModel } from '../../models/DynamicRuleProfileModel';
import { DynamicRuleModel } from '../../models/DynamicRuleModel';

export interface DynamicDataSetState {
  dynamicDataSetState: TileState<DynamicDataSetListModel, DynamicDataSetModel>,
  dynamicRuleState: TileState<DynamicRuleProfileModel, DynamicRuleModel>,
};

let stateReducer;
export function stateReducerWrapper (state = new TileState<DynamicRuleProfileModel, DynamicRuleModel>(), action: actions.Actions<any>): TileState<any, any>  {
  if(!stateReducer){
    stateReducer = listTileReducerFactory(ModuleConfiguration.moduleName, DynamicRuleProfileModel, DynamicRuleModel, new TileState<DynamicRuleProfileModel, DynamicRuleModel>());
  }
  return stateReducer(state, action);
}

export const reducers = {
  dynamicDataSetState: DynamicDataSetReducer,
  dynamicRuleState: stateReducerWrapper
};

export const getDynamicDataSetModuleState = createFeatureSelector(ModuleConfiguration.moduleName);

export const getDynamicDataSetState = createSelector(getDynamicDataSetModuleState, (s: DynamicDataSetState) => s.dynamicDataSetState);
export const getDynamicDataSetList = createSelector(getDynamicDataSetState, (s: TileState<DynamicDataSetListModel, DynamicDataSetModel>) => s.list);
export const getDynamicDataSetListTotalCount = createSelector(getDynamicDataSetState, (s: TileState<DynamicDataSetListModel, DynamicDataSetModel>) => s.totalCount);
export const getDynamicDataSetListLoading = createSelector(getDynamicDataSetState, (s: TileState<DynamicDataSetListModel, DynamicDataSetModel>) => s.loading);
export const getDynamicDataSetListErrors = createSelector(getDynamicDataSetState, (s: TileState<DynamicDataSetListModel, DynamicDataSetModel>) => s.errors);
export const getDynamicDataSetSelection = createSelector(getDynamicDataSetState, (s: TileState<DynamicDataSetListModel, DynamicDataSetModel>) => s.selected);

export const getDynamicRuleState = createSelector(getDynamicDataSetModuleState, (s: DynamicDataSetState) => s.dynamicRuleState);
export const getDynamicRuleListLoading = createSelector(getDynamicRuleState, (s: TileState<DynamicRuleProfileModel, DynamicRuleModel>) => s.loading);
export const getDynamicRuleListErrors = createSelector(getDynamicRuleState, (s: TileState<DynamicRuleProfileModel, DynamicRuleModel>) => s.errors);
export const getDynamicRuleSelection = createSelector(getDynamicRuleState, (s: TileState<DynamicRuleProfileModel, DynamicRuleModel>) => s.selected);




// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/store/reducers/index.ts